module.exports = __webpack_public_path__ + "img/icon-arrow-o.da64a48d.svg";